import { render, staticRenderFns } from "./ProductGalleryOverlay.vue?vue&type=template&id=0db91dd1&scoped=true&"
import script from "./ProductGalleryOverlay.vue?vue&type=script&lang=js&"
export * from "./ProductGalleryOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ProductGalleryOverlay.vue?vue&type=style&index=0&id=0db91dd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db91dd1",
  null
  
)

export default component.exports